export const IMAGES = {
  hero: "/assets/team-photo.jpg",
  squad: "/assets/team-photo.jpg",
  clubhouse: "/assets/pavilion.jpg",
  pavilion: "/assets/pavilion.jpg",
  logo: "/assets/logo-centenary.jpg",
  sponsorNEE: "/assets/sponsor-ne-escapes.webp",
  winners: "/assets/first-xi-winners.jpg",
  juniors: "/assets/juniors-fridays.jpg",
  girls: "/assets/girls-squad.webp",
  juniorNights: "/assets/junior-nights.jpg",
  juniorMatch: "/assets/pitch-7.jpg",
  midweekTeam: "/assets/midweek-team.jpg",
  clubhouseLounge: "/assets/clubhouse-lounge.webp",
  clubmark: "/assets/clubmark.jpg",
  pathway: "/assets/pathway.jpg",
  womensPromo: "/assets/womens-promo.jpg",
  actionA: "/assets/action-a.webp",
  actionB: "/assets/action-b.webp",
  actionC: "/assets/action-c.webp",
  actionD: "/assets/action-d.webp",
  sweep: "/assets/action-sweep.webp",
  team: "https://images.unsplash.com/photo-1785906358742-1b5867519add?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHw0fHxjcmlja2V0JTIwbWF0Y2glMjBhY3Rpb24lMjBwbGF5ZXIlMjBib3dsaW5nJTIwYmF0dGluZyUyMGdyYXNzJTIwcGl0Y2h8ZW58MHx8fHwxNzkwNTM0MjI5fDA&ixlib=rb-4.1.0&q=85",
  batting: "https://images.unsplash.com/photo-1776229705223-d81a45527aa1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxjcmlja2V0JTIwbWF0Y2glMjBhY3Rpb24lMjBwbGF5ZXIlMjBib3dsaW5nJTIwYmF0dGluZyUyMGdyYXNzJTIwcGl0Y2h8ZW58MHx8fHwxNzkwNTM0MjI5fDA&ixlib=rb-4.1.0&q=85",
  lighthouse: "https://images.unsplash.com/photo-1599133743420-952c847cf851?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA6ODl8MHwxfHNlYXJjaHw0fHxsaWdodGhvdXNlJTIwY29hc3RhbCUyMHNlYSUyMHNob3JlJTIwRW5nbGFuZCUyMG5vcnRoJTIwZWFzdHxlbnwwfHx8fDE3OTA1MzQyMzV8MA&ixlib=rb-4.1.0&q=85",
  sea: "https://images.unsplash.com/photo-1623757344638-b93a986ad27b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA6ODl8MHwxfHNlYXJjaHxfHxsaWdodGhvdXNlJTIwY29hc3RhbCUyMHNlYSUyMHNob3JlJTIwRW5nbGFuZCUyMG5vcnRoJTIwZWFzdHxlbnwwfHx8fDE3OTA1MzQyMzV8MA&ixlib=rb-4.1.0&q=85",
  fans: "https://images.unsplash.com/photo-1775642675045-620170196ac5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwz3xzcG9ydHMlMjBjbHViJTIwYmFyJTIwY2x1YmhvdXNlJTIwY29tbXVuaXR5JTIwZ3JvdXAlMjBjZWxlYnJhdGluZyUyMHZpY3Rvcnl8ZW58MHx8fHwxNzkwNTM0MjI5fDA&ixlib=rb-4.1.0&q=85",
};

export const LINKS = {
  facebook: "https://www.facebook.com/whitleybaylocalcricket/",
  playCricket: "https://whitleybay.play-cricket.com/home",
  instagram: "https://www.instagram.com/cricketbay/",
};

export const ADDRESS = "West Park, Hotspur Avenue, Whitley Bay, NE25 8RP";

export const TEAMS = [
  {
    slug: "1st-xi",
    name: "1st XI",
    group: "Senior",
    league: "NTCL Division 3",
    badge: "Div 4 North Champions 2026",
    tagline: "Champions, and on the rise.",
    description:
      "Our First XI were crowned Northumberland & Tyneside Cricket League Division 4 North champions in 2026 and will take on Division 3 next season. Competitive Saturday league cricket at West Park and across the region, with a squad that blends experience and emerging talent.",
    highlights: ["NTCL Division 4 North Champions 2026", "Promoted to Division 3", "Saturday league cricket"],
    image: IMAGES.winners,
    sideImage: IMAGES.actionA,
  },
  {
    slug: "2nd-xi",
    name: "2nd XI",
    group: "Senior",
    league: "NTCL Division 6 South",
    tagline: "The engine room of the club.",
    description:
      "The Second XI compete in Division 6 South of the NTCL — the perfect mix of competitive Saturday cricket and player development, giving young cricketers their first taste of senior league action alongside seasoned campaigners.",
    highlights: ["NTCL Division 6 South", "Pathway to the 1st XI", "Saturday league cricket"],
    image: IMAGES.squad,
    sideImage: IMAGES.actionB,
  },
  {
    slug: "midweek-xi",
    name: "Midweek XI",
    group: "Senior",
    league: "NEMWCL",
    tagline: "Evening cricket under long summer skies.",
    description:
      "Our midweek side plays in the North East Midweek Cricket League — fast, friendly evening cricket that suits busy schedules. A great entry point for new players and a midweek fix for the regulars.",
    highlights: ["North East Midweek Cricket League", "Evening fixtures", "All abilities welcome"],
    image: IMAGES.midweekTeam,
    sideImage: IMAGES.actionC,
  },
  {
    slug: "sunday-xi",
    name: "Sunday XI",
    group: "Senior",
    league: "Friendly fixtures",
    tagline: "Young and old, together on a Sunday.",
    description:
      "The Sunday XI mixes youth and experience in a relaxed friendly format. It is where colts make their senior debut, veterans roll back the years, and families spend Sundays at West Park.",
    highlights: ["Friendly Sunday fixtures", "Mixing young and old", "Colts' first senior cricket"],
    image: "/assets/matchday-dome.webp",
    sideImage: IMAGES.actionD,
  },
  {
    slug: "juniors",
    name: "Junior Section",
    group: "Junior",
    league: "U9 · U11 · U13 · U15",
    badge: "U11 Divisional Champions 2026",
    tagline: "Where Whitley Bay's cricketers are made.",
    description:
      "Junior cricket at U9, U11, U13 and U15, with our U11s crowned divisional champions in 2026. Add ECB All Stars for 5–8 year olds through the summer and there is a place for every child at West Park.",
    highlights: ["U9, U11, U13 and U15 teams", "U11 Divisional Champions 2026", "ECB All Stars every summer"],
    image: IMAGES.juniors,
    sideImage: IMAGES.juniorMatch,
    accreditation: true,
    pathway: true,
  },
  {
    slug: "girls",
    name: "Girls Cricket",
    group: "Junior",
    league: "U11 & U13 Girls",
    tagline: "A fast-growing girls' section.",
    description:
      "We run dedicated U11 and U13 girls' cricket, giving girls their own teams, coaching and fixtures. The girls' section is the foundation of our women's team launching in 2027.",
    highlights: ["U11 and U13 girls' squads", "Dedicated coaching", "Pathway to the women's team"],
    image: IMAGES.girls,
    sideImage: "/assets/ground-bank.webp",
    reel: "https://www.facebook.com/reel/1238165695069426",
  },
  {
    slug: "womens",
    name: "Women's Team",
    group: "Senior",
    league: "Launching 2027",
    badge: "Launching 2027",
    tagline: "The next chapter of Whitley Bay CC.",
    description:
      "In 2027 we launch our women's team — the natural next step for our thriving girls' section and a brand new welcome for women across North Tyneside. Pre-registration is open now: players of all experience levels, including complete beginners.",
    highlights: ["Launching in 2027", "All experience levels welcome", "Pre-registration open now"],
    image: IMAGES.womensPromo,
    sideImage: IMAGES.womensPromo,
    poster: true,
    fundingNote: true,
  },
];

export const HONOURS = [
  {
    year: "2026",
    title: "NTCL Division 4 North Champions",
    detail: "The 1st XI lifted the Division 4 North title and secured promotion to Division 3 for the following season.",
    team: "1st XI",
  },
  {
    year: "2026",
    title: "U11 Divisional Champions",
    detail: "Our Under 11s finished top of their division — a landmark season for the junior section.",
    team: "Junior Section",
  },
  {
    year: "2027",
    title: "Women's Team Launch",
    detail: "A new women's team takes the field, built on the success of our U11 and U13 girls' squads.",
    team: "Women's Cricket",
  },
];

export const SPONSOR_PACKAGES = [
  {
    name: "Match Ball Sponsor",
    price: "Per match",
    description: "Your business named as match ball sponsor across our Saturday fixtures, with mentions in match reports and on social media.",
  },
  {
    name: "Shirt & Kit Sponsor",
    price: "Season",
    description: "Your logo on the playing shirts of our senior or junior teams — visible at every fixture, home and away.",
  },
  {
    name: "Boundary Board Sponsor",
    price: "Season",
    description: "A perimeter board at West Park, seen by players, members and visitors throughout the season.",
  },
  {
    name: "Junior Section Partner",
    price: "Season",
    description: "Support junior and girls' cricket at the club, from All Stars through to our U15s, with recognition across the junior programme.",
  },
];

export const FACILITIES = [
  "Indoor net practice (Active North Tyneside funded)",
  "Clubhouse & pavilion hire",
  "Ground hire at West Park",
];

export const GALLERY = [
  { src: "/assets/team-photo.jpg", category: "Senior", caption: "The whole club together in front of the pavilion" },
  { src: "/assets/first-xi-winners.jpg", category: "Senior", caption: "1st XI — NTCL Division 4 North champions 2026, promoted to Division 3" },
  { src: "/assets/midweek-team.jpg", category: "Senior", caption: "The midweek XI, ready for evening league cricket" },
  { src: "/assets/action-a.webp", category: "Senior", caption: "The bowler runs in at West Park" },
  { src: "/assets/action-b.webp", category: "Senior", caption: "Howzat — the appeal goes up" },
  { src: "/assets/action-c.webp", category: "Senior", caption: "Bails flying on the West Park square" },
  { src: "/assets/action-d.webp", category: "Senior", caption: "Celebration behind the stumps" },
  { src: "/assets/action-e.webp", category: "Senior", caption: "Playing through the off side" },
  { src: "/assets/action-sweep.webp", category: "Senior", caption: "Down on one knee — the sweep" },
  { src: "/assets/action-throw.webp", category: "Senior", caption: "The throw comes in from the deep" },
  { src: "/assets/action-chase.webp", category: "Senior", caption: "Chasing it down at the boundary" },
  { src: "/assets/action-runup.webp", category: "Senior", caption: "Running in with the pavilion behind" },
  { src: "/assets/action-stride.webp", category: "Senior", caption: "Into the delivery stride" },
  { src: "/assets/juniors-fridays.jpg", category: "Juniors", caption: "Friday night junior cricket at the clubhouse" },
  { src: "/assets/junior-nights.jpg", category: "Juniors", caption: "Junior nights on the outfield at West Park" },
  { src: "/assets/pathway.jpg", category: "Juniors", caption: "The WBCC player pathway — All Stars to the 1st XI" },
  { src: "/assets/girls-squad.webp", category: "Girls", caption: "Our girls' squad at their first tournament" },
  { src: "/assets/womens-promo.jpg", category: "Girls", caption: "Women's softball cricket at West Park — all welcome" },
  { src: "/assets/pavilion.jpg", category: "Ground & Pavilion", caption: "The pavilion and new decking at West Park" },
  { src: "/assets/ground-bank.webp", category: "Ground & Pavilion", caption: "Matchday from the bank" },
  { src: "/assets/matchday-dome.webp", category: "Ground & Pavilion", caption: "Summer cricket at West Park" },
  { src: "/assets/match-wide.webp", category: "Ground & Pavilion", caption: "The field set, the clubhouse beyond" },
  { src: "/assets/pitch-ready.webp", category: "Ground & Pavilion", caption: "The square, ready for play" },
  { src: "/assets/pitch-6.jpg", category: "Ground & Pavilion", caption: "Game on beneath the dome" },
  { src: "/assets/pitch-7.jpg", category: "Ground & Pavilion", caption: "Saturday cricket in the sunshine at West Park" },
  { src: "/assets/west-park-nets.jpg", category: "Ground & Pavilion", caption: "The practice nets beneath a big West Park sky" },
  { src: "/assets/clubhouse-lounge.webp", category: "Ground & Pavilion", caption: "The refurbished clubhouse lounge, overlooking the ground" },
  { src: "/assets/ground-shadow.webp", category: "Ground & Pavilion", caption: "Long shadows on the outfield" },
  { src: "/assets/ground-square.webp", category: "Ground & Pavilion", caption: "Fresh lines on the square" },
  { src: "/assets/ground-outfield.webp", category: "Ground & Pavilion", caption: "The outfield catching the evening light" },
  { src: "/assets/bar-interior.webp", category: "Ground & Pavilion", caption: "The new bar inside the pavilion" },
  { src: "/assets/clubhouse-buffet.jpg", category: "Ground & Pavilion", caption: "Matchday hospitality in the clubhouse" },
  { src: "/assets/decking.webp", category: "Ground & Pavilion", caption: "The new decking overlooking the ground" },
  { src: "/assets/ground-roller.webp", category: "Ground & Pavilion", caption: "Rolling the square, the sea on the horizon" },
  { src: "/assets/aerial-ground.webp", category: "Ground & Pavilion", caption: "West Park from the air — cricket by the coast" },
];
